module.exports = "<a (click)=\"changeView('RES', $event)\">Back</a>\n<p-chart class=\"chart left\"type=\"line\" [data]=\"oldData\" (onDataSelect)=\"selectData($event, 1994)\"></p-chart>\n<p-chart class=\"chart right\" type=\"line\" [data]=\"newData\" (onDataSelect)=\"selectData($event, 2014)\"></p-chart>"


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/line-chart/line-chart.component.html
// module id = ../../../../../src/app/line-chart/line-chart.component.html
// module chunks = 0